var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { padding: "10px 0 0 20px" } },
    [
      _vm._m(0),
      _c(
        "div",
        { staticStyle: { "padding-bottom": "10px" } },
        [
          _c(
            "el-dropdown",
            [
              _c("el-button", { attrs: { type: "primary" } }, [
                _vm._v(" 更多菜单 "),
                _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
              ]),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c("el-dropdown-item", [_vm._v("黄金糕")]),
                  _c("el-dropdown-item", [_vm._v("狮子头")]),
                  _c("el-dropdown-item", [_vm._v("螺蛳粉")]),
                  _c("el-dropdown-item", [_vm._v("双皮奶")]),
                  _c("el-dropdown-item", [_vm._v("蚵仔煎")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { width: "600px" } },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.form,
                "label-width": "90px",
                position: "left"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动区域" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择活动区域" },
                      model: {
                        value: _vm.form.region,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "region", $$v)
                        },
                        expression: "form.region"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "区域一", value: "shanghai" }
                      }),
                      _c("el-option", {
                        attrs: { label: "区域二", value: "beijing" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动时间" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "120px" },
                    attrs: { type: "date", placeholder: "选择日期" },
                    model: {
                      value: _vm.form.date1,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "date1", $$v)
                      },
                      expression: "form.date1"
                    }
                  }),
                  _vm._v(" —— "),
                  _c("el-time-picker", {
                    staticStyle: { width: "120px" },
                    attrs: { placeholder: "选择时间" },
                    model: {
                      value: _vm.form.date2,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "date2", $$v)
                      },
                      expression: "form.date2"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "即时配送" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.delivery,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "delivery", $$v)
                      },
                      expression: "form.delivery"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动性质" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.type,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type"
                      }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { label: "美食/餐厅线上活动", name: "type" }
                      }),
                      _c("el-checkbox", {
                        attrs: { label: "地推活动", name: "type" }
                      }),
                      _c("el-checkbox", {
                        attrs: { label: "线下主题活动", name: "type" }
                      }),
                      _c("el-checkbox", {
                        attrs: { label: "单纯品牌曝光", name: "type" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "特殊资源" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.resource,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "resource", $$v)
                        },
                        expression: "form.resource"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "线上品牌商赞助" } }),
                      _c("el-radio", { attrs: { label: "线下场地免费" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "活动形式" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.desc,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "desc", $$v)
                      },
                      expression: "form.desc"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("立即创建")]
                  ),
                  _c("el-button", [_vm._v("取消")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticStyle: { color: "red", "line-height": "30px" } },
      [
        _vm._v(" 注意:下列组件为element-ui标准组件，具体使用方法请参考 "),
        _c(
          "a",
          {
            staticStyle: { color: "blue" },
            attrs: {
              target: "_blank",
              href: "https://element.eleme.cn/#/zh-CN/component/installation"
            }
          },
          [_vm._v("Element官网")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }